"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AffiliateTypeEnum = void 0;
var AffiliateTypeEnum;
(function (AffiliateTypeEnum) {
    AffiliateTypeEnum["Partner"] = "partner";
    AffiliateTypeEnum["Referral"] = "referral";
})(AffiliateTypeEnum = exports.AffiliateTypeEnum || (exports.AffiliateTypeEnum = {}));
//# sourceMappingURL=affiliate-type-enum.js.map